import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import "./style.scss";
import { PencilLine, Trash2, Check, X, ArrowLeft, ArrowRight, Info } from "lucide-react";
import ReactTooltip from "react-tooltip";

const ITEMS_PER_PAGE = 15;

const MembersCard = ({ data, onChangeMember, onDeleteMember, onEditMember }) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editMember, setEditMember] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(data.length / ITEMS_PER_PAGE);
  const offset = currentPage * ITEMS_PER_PAGE;
  const currentItems = data.slice(
    Math.min(currentPage, pageCount - 1) * ITEMS_PER_PAGE,
    Math.min(currentPage, pageCount - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
  );

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    setEditingIndex(null);
  };

  const handleEditClick = (index) => {
    setEditMember({ ...data[index] });
    setEditingIndex(editingIndex === index ? null : index);
  };

  // Save changes for a member row
  const handleRowSave = (index) => {
    if (typeof onEditMember === 'function' && editMember) {
      onEditMember(index, editMember);
    }
    setEditingIndex(null);
    setEditMember(null);
  };

  //  edit member or revert changes
  const handleRowCancel = (index) => {
    if (editMember) {
      onChangeMember(index, "email", editMember.email);
      onChangeMember(index, "join_limit", editMember.join_limit);
      onChangeMember(index, "no_limit", editMember.no_limit);
    }
    setEditingIndex(null);
    setEditMember(null);
  };

  return (
    <div className="manage-members-table-container">
      <table className="manage-members-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Weekly Order Limit</th>
            <th>
              <span className="d-flex align-items-center" data-tip data-for="no-limit-tooltip">
                No Limit Applied
                <Info className="ml-1" />
              </span>

              <ReactTooltip id="no-limit-tooltip" place="bottom" effect="solid">
                By selecting this option allows members to join an unlimited number of orders each day and week.
              </ReactTooltip>
            </th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((member, index) => {
              const actualIndex = offset + index;
              const isEditing = editingIndex === actualIndex;

              return (
                <tr key={member.id || actualIndex} className={isEditing ? "editing-row" : ""}>
                  <td>
                    <input
                      type="email"
                      value={member.email}
                      onChange={(e) =>
                        onChangeMember(actualIndex, "email", e.target.value)
                      }
                      disabled={!isEditing}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      min="0"
                      value={member.join_limit}
                      onChange={(e) =>
                        onChangeMember(
                          actualIndex,
                          "join_limit",
                          e.target.value === "" ? "" : Number(e.target.value)
                        )
                      }
                      disabled={!isEditing}
                      style={{ width: "60px", textAlign: "center" }}
                    />{" "}
                    times / week
                  </td>

                  <td className="limits">
                    <input
                      type="checkbox"
                      checked={member.no_limit}
                      onChange={(e) =>
                        onChangeMember(actualIndex, "no_limit", e.target.checked)
                      }
                      disabled={!isEditing}
                    />
                  </td>

                  <td className="actions">
                    <button
                      type="button"
                      className="edit-btn"
                      onClick={() => handleEditClick(actualIndex)}
                    >
                      {isEditing ? (
                        <>
                          <Check
                            onClick={() => handleRowSave(actualIndex)}
                            size={25}
                            className="check"
                          />
                          <X
                            onClick={() => handleRowCancel(actualIndex)}
                            size={25}
                            className="cancel"
                          />
                        </>
                      ) : (
                        <PencilLine size={20} />
                      )}
                    </button>

                    <button type="button" className="delete-btn">
                      <Trash2
                        onClick={() => onDeleteMember(member.id)}
                        size={20}
                      />
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center", padding: "18px" }}>
                No members found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {data.length > ITEMS_PER_PAGE && (
        <ReactPaginate
          previousLabel={<ArrowLeft size={18} color="var(--brand-primary)" />}
          nextLabel={<ArrowRight size={18} color="var(--brand-primary)" />}
          breakLabel="..."
          pageCount={pageCount}
          forcePage={Math.min(currentPage, pageCount)}
          onPageChange={handlePageChange}
          containerClassName="pagination"
          activeClassName="active"
          previousClassName="prev"
          nextClassName="next"
          disabledClassName="disabled"
        />
      )}
    </div>
  );
};

export default MembersCard;
